module.exports = __webpack_public_path__ + "static/media/texture2.6dd478a9.png";